import { useEffect, useState } from "react";
import TeamSelectorView from "./view";
import Service from "../notification-form/service";
import style from "./style";
import { toast, Zoom } from "react-toastify";
import { debounce } from "@client/utils";

const TeamSelector = ({
  disableNewTeam = false,
  hideNewTeam = false,
  label = "Teams",
  placeholder = "Type or select team(s) from dropdown",
  onChange = () => {},
  users = [],
  value = "",
  teams = [],
  hasValueChanged = () => {},
  onNewTeamCreated = () => {}
}) => {
  const [state, setState] = useState({
    creatingNewTeam: false,
    teams: [],
    teamName: "",
    teamUser: [],
    teamIsPublic: true,
    users: [],
    value: value,
  });

  const getSelectedTeams = (value = "") => {
    const selectedTeams = [];
    if (!value) {
      return value;
    }

    if (typeof value === "string") {
      value = value.split(",");
    }

    value.forEach((id) => {
      const team = state.teams.find((team) => team.id === id);
      if (team) {
        selectedTeams.push(team);
      }
    });

    return selectedTeams;
  };

  const updateSelectedValues = () => {
    setState((prevState) => {
      const newValue = getSelectedTeams(prevState.value);
      return {
        ...prevState,
        value:
          newValue.length === 0 && prevState.value.length > 0
            ? prevState.value
            : newValue,
      };
    });
  };

  const handleCreateNewTeam = () => {
    setState((prevState) => ({ ...prevState, creatingNewTeam: true }));
  };

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      teams,
    }));
  }, [teams]);

  useEffect(() => {
    updateSelectedValues();
  }, [state.teams]);

  const handleChange = (event, values) => {
    event.preventDefault();
    event.stopPropagation();
    setState((prevState) => ({
      ...prevState,
      value: values,
    }));
    onChange(values.map((value) => value.id).join(","));
  };

  const handleTeamName = (event) => {
    const teamName = event.currentTarget.value;
    setState((prevState) => ({
      ...prevState,
      teamName,
    }));
  };

  const handleTeamChange = (event, values) => {
    setState((prevState) => ({
      ...prevState,
      teamUser: values,
    }));
  };

  const handleTeamChecked = (event) => {
    const teamIsPublic = event.currentTarget.checked;
    setState((prevState) => ({
      ...prevState,
      teamIsPublic,
    }));
  };

  const handleTeamModalClose = () =>
    setState((prevState) => ({
      ...prevState,
      creatingNewTeam: false,
      teamName: "",
      teamIsPublic: true,
      teamUser: [],
    }));

  const handleFormSubmit = async () => {
    const teamData = {
      name: state.teamName,
      public: state.teamIsPublic,
      members: state.teamUser.map((user) => ({ email: user.contact.email })),
    };

    toast.info("Saving team, please wait.", {
      autoClose: 2000,
    });
    const timeout = setTimeout(() => {
      toast.info("It is taking longer than expected, please wait.", {
        autoClose: 5000,
        transition: Zoom,
      });
    }, 6000);
    const { data, error } = await Service.createTeam(teamData);
    clearTimeout(timeout);
    if (error) {
      toast.error(Array.isArray(error) ? error[0] && error[0].message : error);
    } else {
      toast.success("Saved successfully.");
      const debouncedOnChange = debounce(onChange, 500);
      setState((prevState) => {
        const newValue =
          typeof prevState.value === "string" ? [] : prevState.value.slice();
        newValue.push(data);
        const newTeams = prevState.teams.slice();
        newTeams.push(data);
        debouncedOnChange(newValue.map((value) => value.id).join(","));
        onNewTeamCreated(data);
        return {
          ...prevState,
          value: newValue,
          creatingNewTeam: false,
          teams: newTeams,
          teamName: "",
          teamIsPublic: true,
          teamUser: [],
        };
      });
    }
  };

  return (
    <>
      <TeamSelectorView
        label={label}
        hideNewTeam={hideNewTeam}
        disableNewTeam={disableNewTeam}
        handleChange={handleChange}
        teams={state.teams}
        placeholder={placeholder}
        value={state.value}
        creatingNewTeam={state.creatingNewTeam}
        handleTeamModalClose={handleTeamModalClose}
        teamName={state.teamName}
        teamUser={state.teamUser}
        users={users}
        teamIsPublic={state.teamIsPublic}
        handleFormSubmit={handleFormSubmit}
        handleCreateNewTeam={handleCreateNewTeam}
        handleTeamChange={handleTeamChange}
        handleTeamChecked={handleTeamChecked}
        handleTeamName={handleTeamName}
      />
    </>
  );
};

export default TeamSelector;
